const AVALIACAO_STATUS = {
  RASCUNHO: { id: 0, descricao: 'Rascunho', color: 'warning' },
  ENVIADA: { id: 1, descricao: 'Enviada', color: 'info' },
  RESPOSTA_INICIADA: { id: 10, descricao: 'Resposta iniciada', color: 'info' },
  RESPOSTA_FINALIZADA: { id: 19, descricao: 'Resposta finalizada', color: 'info' },
  REVISAO_INICIADA: { id: 20, descricao: 'Revisão iniciada', color: 'info' },
  REVISAO_FINALIZADA: { id: 29, descricao: 'Revisão finalizada', color: 'success' },
  PROCESSANDO: { id: 30, descricao: 'Processando', color: 'warning' },
  CONCLUIDA: { id: 40, descricao: 'Concluída', color: 'primary' },
  ERRO: { id: 50, descricao: 'Erro Genérico', color: 'error' },
  ERRO_PROCESSAMENTO: { id: 51, descricao: 'Erro no processamento', color: 'error' },
  RECUSADA: { id: 98, descricao: 'Recusada', color: 'error' },
  CANCELADA: { id: 99, descricao: 'Cancelada', color: 'error' }
};

export default AVALIACAO_STATUS;
